import React, { useState } from "react";
import styles from "./Guide.module.css";
import diffusionIconLight from "../../assets/diffusion_light.svg";
import diffusionIconDark from "../../assets/diffusion_dark.svg";
import menuIconLight from "../../assets/menu_light.svg";
import menuIconDark from "../../assets/menu_dark.svg";
import closeIconLight from "../../assets/close_light.svg";
import closeIconDark from "../../assets/close_dark.svg";
import lightIconActiveLightTheme from "../../assets/light_icon_active_light.svg";
import darkIconActiveDarkTheme from "../../assets/dark_icon_active_dark.svg";
import brainIconLight from "../../assets/brain_light.svg";
import brainIconDark from "../../assets/brain_dark.svg";
import createIconLight from "../../assets/create_light.svg";
import createIconDark from "../../assets/create_dark.svg";
import modifyIconLight from "../../assets/modify_light.svg";
import modifyIconDark from "../../assets/modify_dark.svg";
import selectionIconLight from "../../assets/selection_light.svg";
import selectionIconDark from "../../assets/selection_dark.svg";
import selectionActiveIconLight from "../../assets/selection_active_light.svg";
import selectionActiveIconDark from "../../assets/selection_active_dark.svg";
import copyIconLight from "../../assets/copy_message_light.svg";
import copyIconDark from "../../assets/copy_message_dark.svg";
import loadIconDark from "../../assets/loading_dark.svg";
import loadIconLight from "../../assets/loading_light.svg";
import thumbsUpIconLight from "../../assets/thumbs_up_light.svg";
import thumbsUpIconDark from "../../assets/thumbs_up_dark.svg";
import thumbsDownIconLight from "../../assets/thumbs_down_light.svg";
import thumbsDownIconDark from "../../assets/thumbs_down_dark.svg";
import restoreIconLight from "../../assets/restore_light.svg";
import restoreIconDark from "../../assets/restore_dark.svg";
import createExampleLight from "../../assets/create_light.jpg";
import createExampleDark from "../../assets/create_dark.jpg";
import addExampleLight from "../../assets/adding_light.jpg";
import addExampleDark from "../../assets/adding_dark.jpg";
import subtractExampleLight from "../../assets/subtract_light.jpg";
import subtractExampleDark from "../../assets/subtract_dark.jpg";
import resizeExampleLight from "../../assets/resize_light.jpg";
import resizeExampleDark from "../../assets/resize_dark.jpg";
import moveExampleLight from "../../assets/move_light.jpg";
import moveExampleDark from "../../assets/move_dark.jpg";
import deleteExampleLight from "../../assets/delete_light.jpg";
import deleteExampleDark from "../../assets/delete_dark.jpg";
import counterboreExampleLight from "../../assets/counterbore_light.jpg";
import counterboreExampleDark from "../../assets/counterbore_dark.jpg";
import countersinkExampleLight from "../../assets/countersink_light.jpg";
import countersinkExampleDark from "../../assets/countersink_dark.jpg";
import deleteIconLight from "../../assets/delete_light.svg";
import deleteIconDark from "../../assets/delete_dark.svg";
import boxExampleLight from "../../assets/box_light.jpg";
import boxExampleDark from "../../assets/box_dark.jpg";
import boxSubtractiveExampleLight from "../../assets/box_subtractive_light.jpg";
import boxSubtractiveExampleDark from "../../assets/box_subtractive_dark.jpg";
import cylinderExampleLight from "../../assets/cylinder_light.jpg";
import cylinderExampleDark from "../../assets/cylinder_dark.jpg";
import cylinderSubtractiveExampleLight from "../../assets/cylinder_subtractive_light.jpg";
import cylinderSubtractiveExampleDark from "../../assets/cylinder_subtractive_dark.jpg";
import sphereExampleLight from "../../assets/sphere_light.jpg";
import sphereExampleDark from "../../assets/sphere_dark.jpg";
import sphereSubtractiveExampleLight from "../../assets/sphere_subtractive_light.jpg";
import sphereSubtractiveExampleDark from "../../assets/sphere_subtractive_dark.jpg";
import coneExampleLight from "../../assets/cone_light.jpg";
import coneExampleDark from "../../assets/cone_dark.jpg";
import coneSubtractiveExampleLight from "../../assets/cone_subtractive_light.jpg";
import coneSubtractiveExampleDark from "../../assets/cone_subtractive_dark.jpg";
import torusExampleLight from "../../assets/torus_light.jpg";
import torusExampleDark from "../../assets/torus_dark.jpg";
import torusSubtractiveExampleLight from "../../assets/torus_subtractive_light.jpg";
import torusSubtractiveExampleDark from "../../assets/torus_subtractive_dark.jpg";
import prismExampleLight from "../../assets/prism_light.jpg";
import prismExampleDark from "../../assets/prism_dark.jpg";
import prismSubtractiveExampleLight from "../../assets/prism_subtractive_light.jpg";
import prismSubtractiveExampleDark from "../../assets/prism_subtractive_dark.jpg";
import ellipsoidExampleLight from "../../assets/ellipsoid_light.jpg";
import ellipsoidExampleDark from "../../assets/ellipsoid_dark.jpg";
import ellipsoidSubtractiveExampleLight from "../../assets/ellipsoid_subtractive_light.jpg";
import ellipsoidSubtractiveExampleDark from "../../assets/ellipsoid_subtractive_dark.jpg";
import wedgeExampleLight from "../../assets/wedge_light.jpg";
import wedgeExampleDark from "../../assets/wedge_dark.jpg";
import draftExampleLight from "../../assets/draft_light.jpg";
import draftExampleDark from "../../assets/draft_dark.jpg";
import draft2ExampleLight from "../../assets/draft2_light.jpg";
import draft2ExampleDark from "../../assets/draft2_dark.jpg";
import draft3ExampleLight from "../../assets/draft3_light.jpg";
import draft3ExampleDark from "../../assets/draft3_dark.jpg";
import filletExampleLight from "../../assets/fillet_light.jpg";
import filletExampleDark from "../../assets/fillet_dark.jpg";
import shellExampleLight from "../../assets/shell_light.jpg";
import shellExampleDark from "../../assets/shell_dark.jpg";
import chamferExampleLight from "../../assets/chamfer_light.jpg";
import chamferExampleDark from "../../assets/chamfer_dark.jpg";
import extrudeExampleLight from "../../assets/extrude_light.jpg";
import extrudeExampleDark from "../../assets/extrude_dark.jpg";
import cutExampleLight from "../../assets/cut_light.jpg";
import cutExampleDark from "../../assets/cut_dark.jpg";
import { useTheme } from "../../App";

interface GuideProps {
  onNavigateToHome?: () => void;
  onNavigateToSignUp: () => void;
  onNavigateToLogin: () => void;
}

const Guide: React.FC<GuideProps> = ({
  onNavigateToHome,
  onNavigateToSignUp,
  onNavigateToLogin,
}) => {
  const { theme, setTheme } = useTheme();
  const getActualTheme = (): "light" | "dark" => {
    if (theme === "system") {
      return window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
    }
    return theme as "light" | "dark";
  };

  const actualTheme = getActualTheme();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showFooterBorder, setShowFooterBorder] = useState(true);

  const diffusionIcon =
    actualTheme === "dark" ? diffusionIconDark : diffusionIconLight;
  const menuIcon = actualTheme === "dark" ? menuIconDark : menuIconLight;
  const closeIcon = actualTheme === "dark" ? closeIconDark : closeIconLight;
  const themeIcon =
    theme === "light" ? lightIconActiveLightTheme : darkIconActiveDarkTheme;
  const brainIcon = actualTheme === "dark" ? brainIconDark : brainIconLight;
  const createIcon = actualTheme === "dark" ? createIconDark : createIconLight;
  const modifyIcon = actualTheme === "dark" ? modifyIconDark : modifyIconLight;
  const selectionIcon =
    actualTheme === "dark" ? selectionIconDark : selectionIconLight;
  const selectionActiveIcon =
    actualTheme === "dark" ? selectionActiveIconDark : selectionActiveIconLight;
  const copyIcon = actualTheme === "dark" ? copyIconDark : copyIconLight;
  const thumbsUpIcon =
    actualTheme === "dark" ? thumbsUpIconDark : thumbsUpIconLight;
  const thumbsDownIcon =
    actualTheme === "dark" ? thumbsDownIconDark : thumbsDownIconLight;
  const restoreIcon =
    actualTheme === "dark" ? restoreIconDark : restoreIconLight;
  const deleteIcon = actualTheme === "dark" ? deleteIconDark : deleteIconLight;

  const loadingIcon = actualTheme === "dark" ? loadIconDark : loadIconLight;

  const createExampleImage =
    actualTheme === "dark" ? createExampleDark : createExampleLight; // ADD THIS LINE

  const cutExampleImage =
    actualTheme === "dark" ? cutExampleDark : cutExampleLight; // ADD THIS LINE

  const extrudeExampleImage =
    actualTheme === "dark" ? extrudeExampleDark : extrudeExampleLight; // ADD THIS LINE

  const chamferExampleImage =
    actualTheme === "dark" ? chamferExampleDark : chamferExampleLight; // ADD THIS LINE

  const shellExampleImage =
    actualTheme === "dark" ? shellExampleDark : shellExampleLight; // ADD THIS LINE

  const filletExampleImage =
    actualTheme === "dark" ? filletExampleDark : filletExampleLight; // ADD THIS LINE

  const draftExampleImage =
    actualTheme === "dark" ? draftExampleDark : draftExampleLight; // ADD THIS LINE

  const draft2ExampleImage =
    actualTheme === "dark" ? draft2ExampleDark : draft2ExampleLight; // ADD THIS LINE

  const draft3ExampleImage =
    actualTheme === "dark" ? draft3ExampleDark : draft3ExampleLight; // ADD THIS LINE

  const wedgeExampleImage =
    actualTheme === "dark" ? wedgeExampleDark : wedgeExampleLight; // ADD THIS LINE

  const ellipsoidExampleImage =
    actualTheme === "dark" ? ellipsoidExampleDark : ellipsoidExampleLight; // ADD THIS LINE

  const ellipsoidSubtractiveExampleImage =
    actualTheme === "dark"
      ? ellipsoidSubtractiveExampleDark
      : ellipsoidSubtractiveExampleLight; // ADD THIS LINE

  const prismExampleImage =
    actualTheme === "dark" ? prismExampleDark : prismExampleLight; // ADD THIS LINE

  const prismSubtractiveExampleImage =
    actualTheme === "dark"
      ? prismSubtractiveExampleDark
      : prismSubtractiveExampleLight; // ADD THIS LINE

  const torusExampleImage =
    actualTheme === "dark" ? torusExampleDark : torusExampleLight; // ADD THIS LINE

  const torusSubtractiveExampleImage =
    actualTheme === "dark"
      ? torusSubtractiveExampleDark
      : torusSubtractiveExampleLight; // ADD THIS LINE

  const coneExampleImage =
    actualTheme === "dark" ? coneExampleDark : coneExampleLight; // ADD THIS LINE

  const coneSubtractiveExampleImage =
    actualTheme === "dark"
      ? coneSubtractiveExampleDark
      : coneSubtractiveExampleLight; // ADD THIS LINE

  const sphereExampleImage =
    actualTheme === "dark" ? sphereExampleDark : sphereExampleLight; // ADD THIS LINE

  const sphereSubtractiveExampleImage =
    actualTheme === "dark"
      ? sphereSubtractiveExampleDark
      : sphereSubtractiveExampleLight; // ADD THIS LINE

  const cylinderExampleImage =
    actualTheme === "dark" ? cylinderExampleDark : cylinderExampleLight; // ADD THIS LINE

  const cylinderSubtractiveExampleImage =
    actualTheme === "dark"
      ? cylinderSubtractiveExampleDark
      : cylinderSubtractiveExampleLight; // ADD THIS LINE

  const boxExampleImage =
    actualTheme === "dark" ? boxExampleDark : boxExampleLight; // ADD THIS LINE

  const boxSubtractiveExampleImage =
    actualTheme === "dark"
      ? boxSubtractiveExampleDark
      : boxSubtractiveExampleLight; // ADD THIS LINE

  const addExampleImage =
    actualTheme === "dark" ? addExampleDark : addExampleLight; // ADD THIS LINE
  const resizeExampleImage =
    actualTheme === "dark" ? resizeExampleDark : resizeExampleLight; // ADD THIS LINE
  const moveExampleImage =
    actualTheme === "dark" ? moveExampleDark : moveExampleLight; // ADD THIS LINE
  const deleteExampleImage =
    actualTheme === "dark" ? deleteExampleDark : deleteExampleLight; // ADD THIS LINE
  const counterboreExampleImage =
    actualTheme === "dark" ? counterboreExampleDark : counterboreExampleLight; // ADD THIS LINE
  const countersinkExampleImage =
    actualTheme === "dark" ? countersinkExampleDark : countersinkExampleLight; // ADD THIS LINE

  const subtractExampleImage =
    actualTheme === "dark" ? subtractExampleDark : subtractExampleLight; // ADD THIS LINE
  const handleThemeToggle = () => {
    document.documentElement.classList.add("theme-transitioning");
    setTheme(theme === "light" ? "dark" : "light");
    setTimeout(() => {
      document.documentElement.classList.remove("theme-transitioning");
    }, 0);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  React.useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;

      if (windowHeight + scrollTop >= documentHeight - 10) {
        setShowFooterBorder(false);
      } else {
        setShowFooterBorder(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  React.useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isMenuOpen]);

  return (
    <div className={styles.container}>
      <nav
        className={`${styles.navbar} ${
          isScrolled ? styles.navbarScrolled : ""
        }`}
      >
        <div className={styles.navContent}>
          <button
            className={styles.logoButton}
            onClick={() => {
              window.scrollTo(0, 0);
              if (onNavigateToHome) {
                window.history.pushState({}, "", "/home");
                onNavigateToHome();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <img src={diffusionIcon} alt="Logo" className={styles.logoIcon} />
          </button>

          <div className={styles.desktopMenu}>
            <a
              href="#features"
              className={styles.navLink}
              onClick={(e) => {
                e.preventDefault();
                window.history.pushState({}, "", "/home");
                if (onNavigateToHome) onNavigateToHome();
                setTimeout(() => {
                  document
                    .getElementById("features")
                    ?.scrollIntoView({ behavior: "smooth" });
                }, 100);
              }}
            >
              Features
            </a>
            <a
              href="#pricing"
              className={styles.navLink}
              onClick={(e) => {
                e.preventDefault();
                window.history.pushState({}, "", "/home");
                if (onNavigateToHome) onNavigateToHome();
                setTimeout(() => {
                  document
                    .getElementById("pricing")
                    ?.scrollIntoView({ behavior: "smooth" });
                }, 100);
              }}
            >
              Pricing
            </a>
            <a
              href="#faqs"
              className={styles.navLink}
              onClick={(e) => {
                e.preventDefault();
                window.history.pushState({}, "", "/home");
                if (onNavigateToHome) onNavigateToHome();
                setTimeout(() => {
                  document
                    .getElementById("faqs")
                    ?.scrollIntoView({ behavior: "smooth" });
                }, 100);
              }}
            >
              FAQ's
            </a>
            <a
              href="/guide"
              className={styles.footerLink}
              onClick={(e) => {
                e.preventDefault();
                window.history.pushState({}, "", "/guide");
                window.dispatchEvent(new Event("popstate"));
              }}
            >
              Blog
            </a>
          </div>

          <div className={styles.rightButtons}>
            <div
              className={`${styles.authButtons} ${
                isMenuOpen ? styles.hiddenAuthButtons : ""
              }`}
            >
              <button
                onClick={() => {
                  window.history.pushState({}, "", "/login");
                  onNavigateToLogin();
                }}
                className={styles.loginButton}
              >
                Log in
              </button>
              <button
                onClick={() => {
                  window.history.pushState({}, "", "/signup");
                  onNavigateToSignUp();
                }}
                className={styles.getStartedButton}
              >
                Get started
              </button>
            </div>
          </div>
        </div>
      </nav>

      {isMenuOpen && (
        <div className={styles.mobileMenuDropdown}>
          <div className={styles.mobileMenuContent}>
            <a
              href="#features"
              className={styles.mobileMenuItem}
              onClick={(e) => {
                e.preventDefault();
                setIsMenuOpen(false);
                window.history.pushState({}, "", "/home");
                if (onNavigateToHome) onNavigateToHome();
                setTimeout(() => {
                  document
                    .getElementById("features")
                    ?.scrollIntoView({ behavior: "smooth" });
                }, 100);
              }}
            >
              Features
            </a>
            <div className={styles.menuDivider}></div>
            <a
              href="#pricing"
              className={styles.mobileMenuItem}
              onClick={(e) => {
                e.preventDefault();
                setIsMenuOpen(false);
                window.history.pushState({}, "", "/home");
                if (onNavigateToHome) onNavigateToHome();
                setTimeout(() => {
                  document
                    .getElementById("pricing")
                    ?.scrollIntoView({ behavior: "smooth" });
                }, 100);
              }}
            >
              Pricing
            </a>
            <div className={styles.menuDivider}></div>
            <a
              href="#faqs"
              className={styles.mobileMenuItem}
              onClick={(e) => {
                e.preventDefault();
                setIsMenuOpen(false);
                window.history.pushState({}, "", "/home");
                if (onNavigateToHome) onNavigateToHome();
                setTimeout(() => {
                  document
                    .getElementById("faqs")
                    ?.scrollIntoView({ behavior: "smooth" });
                }, 100);
              }}
            >
              FAQ's
            </a>
            <div className={styles.menuDivider}></div>
            <a
              href="/guide"
              className={styles.footerLink}
              onClick={(e) => {
                e.preventDefault();
                window.history.pushState({}, "", "/guide");
                window.dispatchEvent(new Event("popstate"));
              }}
            >
              Blog
            </a>
          </div>

          <div className={styles.mobileMenuButtons}>
            <button
              onClick={() => {
                window.history.pushState({}, "", "/signup");
                onNavigateToSignUp();
              }}
              className={styles.mobileGetStartedButton}
            >
              Get started
            </button>
            <button
              onClick={() => {
                window.history.pushState({}, "", "/login");
                onNavigateToLogin();
              }}
              className={styles.mobileLoginButton}
            >
              Log in
            </button>
          </div>
        </div>
      )}

      <div className={styles.pageContent}>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>Getting Started with Noah (Beta)</h1>
          <p className={styles.para}>
            Noah is a text-driven CAD modeling system for creating parametric 3D
            parts. You describe geometry in plain language, and Noah builds the
            model feature by feature.
          </p>
          <p className={styles.para}>
            This guide explains how to work with Noah effectively, from basic
            operations to advanced features, using the same structured workflow
            an engineer would follow in a traditional CAD tool.
          </p>
          <div className={styles.divider}></div>
          <h1 className={styles.subheader}>How Noah Works</h1>
          <p className={styles.para}>
            Noah uses a sequential modeling workflow. Each prompt creates,
            modifies, or removes a specific feature in the model’s history.
            <ul>
              <li>Start with a base shape</li>
              <li>Add or remove material</li>
              <li>Refine dimensions, placement, and features</li>
              <li>Iterate as needed</li>
            </ul>
            This approach gives you full control over geometry, parameters, and
            design intent.
          </p>
          <div className={styles.divider}></div>
          <h1 className={styles.subheader}>How to Use This Guide</h1>
          <p className={styles.para}>
            This guide is designed to be read progressively, but each section
            also works as a reference.
            <ul>
              <li>
                Section 1 introduces core operations (Create, Edit, Delete,
                Branch)
              </li>
              <li>Section 2 covers primitive shapes</li>
              <li>
                Section 3 explains modeling features like fillets, shells,
                drafts, and cuts
              </li>
            </ul>
            You are encouraged to follow along and try the prompts yourself.
          </p>

          <h2 className={styles.subHeader3}>1. Operations</h2>

          <div className={styles.exampleSection}>
            <div className={styles.operationPill}>Create</div>

            <li className={styles.exampleDescription}>
              Create is the starting point for every model in Noah. It generates
              the initial geometry and defines it as a Body, which all
              subsequent features modify. Use Create to establish the base shape
              of your part before adding or removing material.
            </li>

            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Create</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    create a 30 x 4 x 50 mm base plate
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 18s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={createIcon}
                          alt="Create"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Box001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionText}>
                        0 Faces, 0 Edges
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've got your 30 x 4 x 50 mm base plate set. I’d add a 2 mm
                    fillet to the outer edges to soften it and reduce sharpness.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={createExampleImage}
                    alt="Create example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.exampleSection}>
            <div className={styles.operationPill}>Edit</div>

            <li className={styles.exampleDescription}>
              Edit modifies existing geometry in the model. Use this operation
              to add material, remove material, or adjust previously created
              features.
            </li>

            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Add</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    extrude a 30 x 3 x 27 mm wall on the top edge
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 16s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Extrude001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        1 Face
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've extruded a 30 x 3 x 27 mm wall along the top edge. I’d
                    suggest filleting the outer edge to smooth it and reduce
                    stress.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={addExampleImage}
                    alt="Add example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Subtract</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    drill a 6 mm hole at a depth of 1 mm
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 12s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Cut001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        1 Face
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've drilled the 6 mm hole to a depth of 1 mm. I could
                    chamfer the hole edge to ease insertion.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={subtractExampleImage}
                    alt="Subtract example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Resize</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    edit Cut001 to go all the way through instead
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 29s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Cut001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionText}>
                        0 Faces, 0 Edges
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've updated Cut001 to go all the way through. I'd add a
                    small chamfer on the exit edge to ease assembly.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={resizeExampleImage}
                    alt="Resize example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Move</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    move Cut001 to be 4.5 mm from the left edge
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 24s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Cut001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionText}>
                        0 Faces, 0 Edges
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've moved Cut001 to 4.5 mm from the left edge. I’d suggest
                    adding a 0.5 mm fillet on that edge to smooth the
                    transition.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={moveExampleImage}
                    alt="Move example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.exampleSection}>
            <div className={styles.operationPill}>Delete</div>

            <li className={styles.exampleDescription}>
              Delete permanently removes a selected Feature or Body from the
              model. Because Noah builds models sequentially, deleting a feature
              also removes all features created after it in the feature history.
            </li>

            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Delete</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>delete Cut001</div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 15s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={deleteIcon}
                          alt="Delete"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Cut001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionText}>
                        0 Faces, 0 Edges
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've deleted Cut001. We could add a mounting hole.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={addExampleImage}
                    alt="Delete example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.exampleSection}>
            <div className={styles.operationPill}>Branch</div>

            <li className={styles.exampleDescription}>
              Branch creates a new, independent version of the model from a
              selected point in the feature history. Use Branch to explore
              alternative designs without affecting the original model or
              deleting existing features.
            </li>

            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Branch</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    drill a 6 mm hole at a depth of 1 mm
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 12s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={createIcon}
                          alt="Create"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Cut001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        1 Face
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've drilled the 6 mm hole to a depth of 1 mm. I could
                    chamfer the hole edge to ease insertion.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={loadingIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.branch}>Branching...</button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={subtractExampleImage}
                    alt="Create example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
          </div>

          <h2 className={styles.subHeader3}>2. Primitives</h2>
          <p className={styles.para}>
            Every model in Noah begins with a Primitive. Primitives are basic 3D
            shapes used to either add or remove material from a Body and
            establish its overall geometry. Additive Primitives create new solid
            geometry, while Subtractive Primitives remove material from existing
            solids. All subsequent features modify or refine geometry created
            through these operations.
          </p>
          <div className={styles.exampleSection2}>
            <div className={styles.primitivePill}>
              Box (Additive / Subtractive)
            </div>
            <li className={styles.exampleDescription}>
              Creates or removes a rectangular volume defined along the Y, Z,
              then X axes (Width × Height × Depth). Use it to form solid block
              geometry or to cut rectangular features from existing bodies.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Box (Additive)</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    create a 15.8 x 9.6 x 31.8 mm box
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 10s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={createIcon}
                          alt="Create"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Box001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionText}>
                        0 Faces, 0 Edges
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've got the 15.8 x 9.6 x 31.8 mm box set. I'd add small
                    corner fillets, about 0.5 mm, to soften the edges.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={boxExampleImage}
                    alt="Box example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Box (Subtractive)</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    subtract a 15.8 x 9.6 x 31.8 mm box
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 11s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Box002
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        1 Face
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've subtracted a 15.8 x 9.6 x 31.8 mm box from the model.
                    We could add a small fillet to the exposed edges to smooth
                    things out.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={boxSubtractiveExampleImage}
                    alt="Box Subtractive example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.draftPill}>
              Cylinder (Additive / Subtractive)
            </div>
            <li className={styles.exampleDescription}>
              Creates or removes a cylindrical volume defined by a radius and a
              depth along the X axis. Use it to form round solids such as posts
              or rods, or to cut holes and cylindrical features from existing
              bodies.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Cylinder (Additive)</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    create a cylinder 15 mm radius and 25 mm deep
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 10s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={createIcon}
                          alt="Create"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Cylinder001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionText}>
                        0 Faces, 0 Edges
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've got your cylinder set up with a 15 mm radius and 25 mm
                    tall. We could add a small 0.5 mm fillet to the top and
                    bottom edges to soften the ends.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={cylinderExampleImage}
                    alt="Cylinder example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>
                  Cylinder (Subtractive)
                </span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    subtract a cylinder 7.5 mm radius and 12.5 mm deep
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 16s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Cylinder001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        1 Face
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've cut a cylinder with a 7.5 mm radius and 12.5 mm depth.
                    We could fillet the cut edge to smooth the transition.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={cylinderSubtractiveExampleImage}
                    alt="Cylinder Subtractive example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.draftPill}>
              Sphere (Additive / Subtractive)
            </div>
            <li className={styles.exampleDescription}>
              Creates or removes a spherical volume defined by a radius. The
              sphere is uniform in all directions and centered on its origin.
              Use it to add rounded solid forms or to subtract material when
              creating spherical cavities.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Sphere (Additive)</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    build a small sphere, 8 mm radius
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 16s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={createIcon}
                          alt="Create"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Sphere001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionText}>
                        0 Faces, 0 Edges
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've got your sphere with 8mm radius. I could shell it to a
                    thin-walled hollow sphere if you want.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={sphereExampleImage}
                    alt="Sphere example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>
                  Sphere (Subtractive)
                </span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    subtract a sphere with a 12.5 mm radius
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 13s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Sphere001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        1 Face
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've subtracted a sphere with a 12.5 mm radius from the
                    part. I’d add a small fillet along the cut edge to smooth it
                    and reduce stress.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={sphereSubtractiveExampleImage}
                    alt="Sphere Subtractive example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.draftPill}>
              Cone (Additive / Subtractive)
            </div>
            <li className={styles.exampleDescription}>
              Creates a solid or void conical feature defined by a base radius,
              top radius, and depth along the X axis. Use it for tapered solids,
              funnels, bores, or other conical geometry.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Cone (Additive)</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    add a cone 15 mm base tapering to 5 mm, 30 mm deep
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 13s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={createIcon}
                          alt="Create"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Cone001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionText}>
                        0 Faces, 0 Edges
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've added the cone frustum with a 15 mm base tapering to 5
                    mm over a 30 mm height. We could add a small fillet on the
                    base edge to smooth it.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={coneExampleImage}
                    alt="Cone example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Cone (Subtractive)</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    subtract a cone 12.5 mm base tapering to 5 mm, 25 mm deep
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 8s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Cone001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        1 Face
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've added the conical cut with a base diameter of 12.5 mm
                    tapering to 5 mm over 25 mm depth. I’d add a small fillet on
                    the cut edge to smooth the transition.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={coneSubtractiveExampleImage}
                    alt="Cone Subtractive example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.draftPill}>
              Torus (Additive / Subtractive)
            </div>
            <li className={styles.exampleDescription}>
              Creates a solid ring-shaped form defined by a major (outer) radius
              and a minor (tube) radius. Use it for rings, loops, or circular
              tubes: either as an additive solid or as a subtractive primitive
              to cut ring-shaped voids from other geometry.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Torus (Additive)</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    make a torus 15 mm major 3 mm minor radius
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 13s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={createIcon}
                          alt="Create"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Torus001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionText}>
                        0 Faces, 0 Edges
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've got your torus set up with a 15mm major radius and a
                    3mm minor radius. We could shell it to 1mm walls to make a
                    hollow ring.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={torusExampleImage}
                    alt="Torus example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Torus (Subtractive)</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    subtract a torus 12.5 mm major 5 mm minor radius
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 9s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Torus001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        1 Face
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've subtracted a torus with a 12.5 mm major radius and 5 mm
                    minor radius. I’d add a small fillet on the cut edge to
                    smooth it.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={torusSubtractiveExampleImage}
                    alt="Torus Subtractive example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.draftPill}>
              Prism (Additive / Subtractive)
            </div>
            <li className={styles.exampleDescription}>
              Creates a solid or subtractive prism with a hexagonal base,
              defined by its width (Y axis) across flats and depth along the X
              axis. Use it for nuts, bolts, or any six-sided extrusions.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Prism (Additive)</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    build a hexagon prism, 12 mm across and 20 mm deep
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 14s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={createIcon}
                          alt="Create"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Prism001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionText}>
                        0 Faces, 0 Edges
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've set up a hexagonal prism with 12mm across flats and
                    20mm tall. We could add a center through hole.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={prismExampleImage}
                    alt="Prism example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Prism (Subtractive)</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    subtract a hexagon prism, 12.5 mm across and 25 mm deep
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 18s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Prism001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        1 Face
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've subtracted a hexagon prism 12.5 mm across and 25 mm
                    deep to create the pocket. I’d add a small fillet on the
                    internal corners to reduce stress.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={prismSubtractiveExampleImage}
                    alt="Prism Subtractive example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.draftPill}>
              Ellipsoid (Additive / Subtractive)
            </div>
            <li className={styles.exampleDescription}>
              Creates a smooth, oval-shaped solid defined by width, height, and
              depth. Can be used additively or subtractively, making it ideal
              for eggs, ovals, or any rounded form.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>
                  Ellipsoid (Additive)
                </span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    create an ellipsoid 15 by 10 by 8 mm
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 12s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={createIcon}
                          alt="Create"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Ellipsoid001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionText}>
                        0 Faces, 0 Edges
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've got your ellipsoid 15x10x8 set up. I’d add a small
                    fillet on the edge to soften the surface.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={ellipsoidExampleImage}
                    alt="Ellipsoid example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>
                  Ellipsoid (Subtractive)
                </span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    subtract an ellipsoid 20 by 15 by 10 mm
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 11s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Ellipsoid001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        1 Face
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've subtracted an ellipsoid 20 by 15 by 10 mm from the
                    part. We could add a fillet to the inner edges where the cut
                    meets the body to smooth the transition.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={ellipsoidSubtractiveExampleImage}
                    alt="Ellipsoid Subtractive example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            {/* <div className={styles.draftPill}>Wedge (Additive)</div>
            <li className={styles.exampleDescription}>
              Creates a solid triangular prism defined by width, height, and
              depth. Use it for ramps, inclined planes, or any tapered block.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Wedge (Additive)</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    make a wedge shape, 40 x 25 x 15 mm
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 16s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={createIcon}
                          alt="Create"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Wedge001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionText}>
                        0 Faces, 0 Edges
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've got your wedge created at 40 by 25 by 15. We could
                    chamfer the top edge by 1 mm to make handling smoother.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={wedgeExampleImage}
                    alt="Wedge example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div> */}
          </div>

          <h2 className={styles.subHeader3}>3. Features</h2>
          <p className={styles.para}>
            Features are the parametric operations used to shape and refine a
            Body. They add, remove, or modify geometry created from a Primitive,
            allowing you to build complex, manufacturable parts step by step.
          </p>
          <div className={styles.exampleSection2}>
            <div className={styles.primitivePill}>Extrude (Additive)</div>
            <li className={styles.exampleDescription}>
              Creates a solid by extending a 2D shape along a straight path for
              a specified height (thickness). Use it to create 3D circles,
              squares, rectangles, or custom shapes into 3D solids.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Extrude (Additive)</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    extrude a 4.8 mm circle, 1.8 mm high
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 15s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Extrude001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        1 Face
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've extruded the 4.8 mm circle to 1.8 mm high. We could add
                    a small fillet to the top edge for a smoother finish.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={extrudeExampleImage}
                    alt="Extrude example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.draftPill}>Cut (Subtractive)</div>
            <li className={styles.exampleDescription}>
              Removes material by extending a 2D shape along a path for a
              specified depth, carving out space from existing solids. Use it
              for holes, slots, or any negative features.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Cut (Subtractive)</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    cut a 4.8 mm circle, 1.8 mm deep
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 13s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Cut001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        1 Face
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've cut a 4.8 mm circle to a depth of 1.8 mm. We could
                    fillet the pocket edge to smooth it.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={cutExampleImage}
                    alt="Cut example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <li className={styles.exampleDescription2}>
              Creates a stepped hole with a smaller through hole and a larger
              flat-bottomed recess at the top, defined by inner diameter, outer
              diameter, and counterbore depth. Use it for socket-head screws or
              bolts that need a flush seat.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>
                  {" "}
                  Cut (Subtractive) 2/3
                </span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    drill a 3 mm counterbore hole, 6 mm wide, 1.5 mm deep
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 23s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Cut001
                        </span>
                      </div>
                    </div>{" "}
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Cut002
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        1 Face
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've added a 3 mm hole with a 6 mm counterbore to a depth of
                    1.5 mm. I'd add a small fillet at the counterbore rim to
                    smooth the transition.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={counterboreExampleImage}
                    alt="Counterbore example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <li className={styles.exampleDescription2}>
              Creates a conical hole with a smaller shaft and an angled top
              recess, defined by hole diameter, top diameter, and sink angle
              (90° by default). Use it for flat-head screws that need to sit
              flush with the surface.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>
                  {" "}
                  Cut (Subtractive) 3/3
                </span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    drill a 3 mm countersink hole, 6 mm wide
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 19s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Cut001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Cut002
                        </span>
                      </div>
                    </div>

                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        1 Face
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've added a 3 mm hole with a 6 mm countersink. We could add
                    a small fillet on the hole entrance to reduce stress and
                    burrs.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={countersinkExampleImage}
                    alt="Countersink example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.draftPill}>Shell (Subtractive)</div>
            <li className={styles.exampleDescription}>
              Hollows out a solid by removing material from selected faces,
              leaving walls of a specified thickness. Use it to make thin-walled
              parts, containers, or enclosures.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Shell (Subtractive)</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    shell this face by 1 mm
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 20s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Shell001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        1 Face
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've shelled that face by 1 mm. I’d add a small fillet on
                    the outside edge to reduce stress.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={shellExampleImage}
                    alt="Shell example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.draftPill}>Draft (Modifier)</div>
            <li className={styles.exampleDescription}>
              Drafts are used to add a taper to faces, commonly for
              manufacturing and molding. To create a draft, select a face, then
              choose where on that face the draft should originate and set the
              desired draft angle.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>
                  Draft (Modifier) 1/3
                </span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    draft 25 degrees from the top
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 8s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Draft001
                        </span>
                      </div>
                    </div>

                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        1 Face
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've drafted the top face at 25 degrees. I could add a
                    second draft on the opposite face for symmetry.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={draftExampleImage}
                    alt="Draft example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <li className={styles.exampleDescription2}>
              By default, drafts are applied inward, meaning the face tapers
              toward the interior of the model. You can also specify an outward
              draft, which tapers away from the model instead. The draft
              direction can be changed at any time by editing the draft.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>
                  {" "}
                  Draft (Modifier) 2/3
                </span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    change Draft001 to be outward
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 20s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Draft001
                        </span>
                      </div>
                    </div>

                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionText}>
                        0 Faces, 0 Edges
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    Draft001 is outward now. I’d tweak the draft angle a bit to
                    ensure smooth release if you want.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={draft2ExampleImage}
                    alt="Draft example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <li className={styles.exampleDescription2}>
              Once a draft is created, you are not locked into the original
              settings. You can edit an existing draft to adjust its angle,
              switch between inward and outward directions, or redefine the
              reference edge or direction from which the draft is applied.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>
                  {" "}
                  Draft (Modifier) 3/3
                </span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    change Draft001 to go from the left
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 21s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Draft001
                        </span>
                      </div>
                    </div>

                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionText}>
                        0 Faces, 0 Edges
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've updated Draft001 to originate from the left. I’d set
                    the draft angle to a light 1–2 degrees for easier release.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={draft3ExampleImage}
                    alt="Draft example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.draftPill}>Fillet (Modifier)</div>
            <li className={styles.exampleDescription}>
              Rounds the edges or corners of a solid by a specified radius. Use
              it to smooth sharp edges, improve aesthetics, or reduce stress
              concentrations.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Fillet (Modifier)</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    fillet these edges by 2 mm
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 8s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Fillet001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        4 Edges
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've filleted those edges by 2 mm. I’d also chamfer the
                    outer edges a bit for easier assembly.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={filletExampleImage}
                    alt="Fillet example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>
            <div className={styles.draftPill}>Chamfer (Modifier)</div>
            <li className={styles.exampleDescription}>
              Bevels the edges or corners of a solid by a specified distance or
              angle. Use it to create angled edges, simplify assembly, or remove
              sharp corners.
            </li>
            <div className={styles.exampleCard}>
              <div className={styles.exampleHeader}>
                <span className={styles.exampleTitle}>Chamfer (Modifier)</span>
              </div>
              <div className={styles.exampleBody}>
                <div className={styles.exampleLeft}>
                  <div className={styles.exampleUserMessage}>
                    chamfer these edges by 2 mm
                  </div>

                  <div className={styles.exampleThinkingContainer}>
                    <img
                      src={brainIcon}
                      alt="Thought"
                      className={styles.exampleThinkingIcon}
                    />
                    <span className={styles.exampleThinkingText}>
                      Thought for 12s
                    </span>
                  </div>

                  <div className={styles.exampleFeatureBox}>
                    <div className={styles.exampleFeatureItem}>
                      <div className={styles.exampleFeatureItemLeft}>
                        <img
                          src={modifyIcon}
                          alt="Modify"
                          className={styles.exampleFeatureIcon}
                        />
                        <span className={styles.exampleFeatureText}>
                          Chamfer001
                        </span>
                      </div>
                    </div>
                    <div className={styles.exampleSelectionContext}>
                      <img
                        src={selectionActiveIcon}
                        alt="Selection"
                        className={styles.exampleSelectionIcon}
                      />
                      <span className={styles.exampleSelectionTextActive}>
                        4 Edges
                      </span>
                    </div>
                  </div>

                  <p className={styles.exampleAiText}>
                    I've chamfered those edges by 2 mm. I’d also add a 0.5 mm
                    fillet on the internal corners to smooth stress
                    concentrations.
                  </p>

                  <div className={styles.exampleActions}>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={copyIcon}
                        alt="Copy"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsUpIcon}
                        alt="Thumbs up"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={thumbsDownIcon}
                        alt="Thumbs down"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                    <button className={styles.exampleActionButton}>
                      <img
                        src={restoreIcon}
                        alt="Branch"
                        className={styles.exampleActionIcon}
                      />
                    </button>
                  </div>
                </div>
                <div className={styles.exampleRight}>
                  <img
                    src={chamferExampleImage}
                    alt="Chamfer example"
                    className={styles.exampleImage}
                  />
                </div>
              </div>
            </div>

            <h2 className={styles.subHeader3}>4. Need help?</h2>
            <p className={styles.para}>
              This guide covered the core concepts required to build parametric
              models in Noah: operations, primitives, and features. If you
              encounter unexpected behavior, edge cases, or limitations, keep in
              mind that Noah is currently in Beta and continues to evolve based
              on real-world usage.
            </p>

            <p className={styles.para}>
              For real-time help, workflow tips, and discussion with other
              users, join the Noah community on{" "}
              <a
                href="https://discord.com/invite/mYG5ZDfmP7"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                Discord
              </a>
              .
            </p>
            <p className={styles.para}>
              For technical issues or account-related questions, contact us at{" "}
              <a
                href="https://gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                support@noahcad.com
              </a>
              .
            </p>
          </div>
        </div>
      </div>

      <footer
        className={`${styles.footer} ${
          showFooterBorder ? styles.footerBordered : ""
        }`}
      >
        <div className={styles.footerContent}>
          <div
            className={styles.footerLogo}
            onClick={() => {
              window.scrollTo(0, 0);
              if (onNavigateToHome) {
                window.history.pushState({}, "", "/home");
                onNavigateToHome();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <img src={diffusionIcon} alt="Logo" className={styles.logoIcon} />
          </div>

          <div className={styles.footerGrid}>
            <div className={styles.footerColumn}>
              <h3 className={styles.footerColumnTitle}>Product</h3>
              <a
                href="#features"
                className={styles.footerLink}
                onClick={(e) => {
                  e.preventDefault();
                  window.history.pushState({}, "", "/home");
                  if (onNavigateToHome) onNavigateToHome();
                  setTimeout(() => {
                    document
                      .getElementById("features")
                      ?.scrollIntoView({ behavior: "smooth" });
                  }, 100);
                }}
              >
                Features
              </a>
              <a
                href="#pricing"
                className={styles.footerLink}
                onClick={(e) => {
                  e.preventDefault();
                  window.history.pushState({}, "", "/home");
                  if (onNavigateToHome) onNavigateToHome();
                  setTimeout(() => {
                    document
                      .getElementById("pricing")
                      ?.scrollIntoView({ behavior: "smooth" });
                  }, 100);
                }}
              >
                Pricing
              </a>
              <a
                href="#faqs"
                className={styles.footerLink}
                onClick={(e) => {
                  e.preventDefault();
                  window.history.pushState({}, "", "/home");
                  if (onNavigateToHome) onNavigateToHome();
                  setTimeout(() => {
                    document
                      .getElementById("faqs")
                      ?.scrollIntoView({ behavior: "smooth" });
                  }, 100);
                }}
              >
                FAQ's
              </a>
            </div>

            <div className={styles.footerColumn}>
              <h3 className={styles.footerColumnTitle}>Company</h3>
              <a
                href="/guide"
                className={styles.footerLink}
                onClick={(e) => {
                  e.preventDefault();
                  window.history.pushState({}, "", "/guide");
                  window.dispatchEvent(new Event("popstate"));
                }}
              >
                Blog
              </a>
            </div>

            <div className={styles.footerColumn}>
              <h3 className={styles.footerColumnTitle}>Resources</h3>
              <a
                href="/guide"
                className={styles.footerLink}
                onClick={(e) => {
                  e.preventDefault();
                  window.history.pushState({}, "", "/guide");
                  window.dispatchEvent(new Event("popstate"));
                }}
              >
                Modeling guide
              </a>
              <a
                href="/terms"
                className={styles.footerLink}
                onClick={(e) => {
                  e.preventDefault();
                  window.history.pushState({}, "", "/terms");
                  window.dispatchEvent(new Event("popstate"));
                }}
              >
                Terms of service
              </a>
              <a
                href="/privacy"
                className={styles.footerLink}
                onClick={(e) => {
                  e.preventDefault();
                  window.history.pushState({}, "", "/privacy");
                  window.dispatchEvent(new Event("popstate"));
                }}
              >
                Privacy policy
              </a>
            </div>
          </div>

          <div className={styles.footerBottom}>
            <div className={styles.footerSocial}>
              {/* <button
                className={styles.themeButton}
                onClick={handleThemeToggle}
              >
                <img
                  src={themeIcon}
                  alt="Toggle theme"
                  className={styles.themeIcon}
                />
              </button> */}
              <a
                href="https://x.com/cadwithnoah"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a
                href="https://bsky.app/profile/noahcad.com"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.02.275-.039.415-.056-.138.022-.276.04-.415.056-3.912.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078a8.741 8.741 0 0 1-.415-.056c.14.017.279.036.415.056 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.206-.659-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8Z" />
                </svg>
              </a>
              <a
                href="https://www.threads.net/@cadwithnoah"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 192 192"
                  fill="currentColor"
                >
                  <path d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z" />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@noahcad"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
              </a>
              <a
                href="https://www.tiktok.com/@cadwithnoah"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
                </svg>
              </a>
              <a
                href="https://www.reddit.com/r/NoahCAD/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/noahcad"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/cadwithnoah/?igsh=MWkwbGd2bnNmZWIzNg%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
              <a
                href="https://discord.gg/mYG5ZDfmP7"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
                </svg>
              </a>
            </div>
            <div className={styles.footerCopyright}>
              <span className={styles.copyright}>©</span> Noah 2026. All rights
              reserved.
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};
export default Guide;
